export const PRODUCT_TAB_CAKE = "BANH";
export const PRODUCT_TAB_BOX = "HOP";

const toNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

export const isBoxProduct = (product) =>
  String(product?.MaLBTT || "")
    .trim()
    .toUpperCase() === PRODUCT_TAB_BOX;

export const filterProductsByTab = (products, productTab) =>
  products.filter((product) =>
    productTab === PRODUCT_TAB_BOX
      ? isBoxProduct(product)
      : !isBoxProduct(product)
  );

export const sortProductsByExpiry = (products, getExpiryDays) =>
  products
    .map((product, originalIndex) => ({
      product,
      originalIndex,
      expiryDays: getExpiryDays(product),
    }))
    .sort((left, right) => {
      const leftHasExpiry =
        left.expiryDays !== null &&
        left.expiryDays !== undefined &&
        left.expiryDays !== "" &&
        Number.isFinite(Number(left.expiryDays));
      const rightHasExpiry =
        right.expiryDays !== null &&
        right.expiryDays !== undefined &&
        right.expiryDays !== "" &&
        Number.isFinite(Number(right.expiryDays));

      if (leftHasExpiry && rightHasExpiry) {
        const expiryDifference =
          Number(left.expiryDays) - Number(right.expiryDays);
        return expiryDifference || left.originalIndex - right.originalIndex;
      }
      if (leftHasExpiry) return -1;
      if (rightHasExpiry) return 1;
      return left.originalIndex - right.originalIndex;
    })
    .map(({ product }) => product);

export const calculateProductTableTotals = (
  products,
  { isAllStoresMode, maCH }
) => {
  const totals = {
    soLuongNhap: 0,
    soLuongNhapDieuPhoi: 0,
    soLuongNhapDieuChuyen: 0,
    soLuongBan: 0,
    soLuongDieuChuyen: 0,
    soLuongTraVe: 0,
    soLuongKiemKe: 0,
    tonKho: 0,
    thanhTienNhap: 0,
    thanhTienBan: 0,
    storeCount: 0,
  };
  const storesWithStock = new Set();

  products.forEach((product) => {
    totals.soLuongNhap += toNumber(
      isAllStoresMode ? product.totalSoLuongNhap : product.SoLuongNhap
    );
    totals.soLuongNhapDieuPhoi += toNumber(
      isAllStoresMode
        ? product.totalSoLuongNhapDieuPhoi
        : product.SoLuongNhapDieuPhoi
    );
    totals.soLuongNhapDieuChuyen += toNumber(
      isAllStoresMode
        ? product.totalSoLuongNhapDieuChuyen
        : product.SoLuongNhapDieuChuyen
    );
    totals.soLuongBan += toNumber(
      isAllStoresMode ? product.totalSoLuongBan : product.SoLuongBan
    );
    totals.soLuongDieuChuyen += toNumber(
      isAllStoresMode
        ? product.totalSoLuongDieuChuyen
        : maCH === "20"
        ? product.SoLuongPhanBo
        : product.SoLuongDieuChuyen
    );
    totals.soLuongTraVe += toNumber(
      isAllStoresMode ? product.totalSoLuongTraVe : product.SoLuongTraVe
    );
    totals.soLuongKiemKe += toNumber(
      isAllStoresMode ? product.totalSoLuongKiemKe : product.SoLuongKiemKe
    );
    totals.tonKho += toNumber(
      isAllStoresMode ? product.totalTonKho : product.TonKho
    );
    totals.thanhTienNhap += toNumber(
      isAllStoresMode ? product.totalThanhTienNhap : product.ThanhTienNhap
    );
    totals.thanhTienBan += toNumber(
      isAllStoresMode ? product.totalThanhTienBan : product.ThanhTienBan
    );

    if (isAllStoresMode && Array.isArray(product.stores)) {
      product.stores.forEach((store) => {
        if (toNumber(store.TonKho) > 0) {
          storesWithStock.add(String(store.storeId));
        }
      });
    }
  });

  totals.storeCount = storesWithStock.size;
  return totals;
};
